<script type="text/ecmascript-6">
    import {modelToolHelpers} from '../../../../vendor/rmts/scoop-os/resources/js/mixins/model-tool-helpers'

    export default {
        mixins: [
            modelToolHelpers()
        ],
        computed: {
            discontinuedCount() {
                return this.countApplicableModels('ThomassaboModelSelectorToolsDiscontinuedMediaFlagWarning');
            },
            ecomCount() {
                // return this.countApplicableModels('ThomassaboModelSelectorToolsEcomMediaFlagWarning');
                return 0
            }
        }
    }
</script>
<template>
    <div class="dropdown" v-if="discontinuedCount > 0 || ecomCount > 0">
        <a class="dropdown-toggle" type="button" id="mediaFlagDropdown" data-toggle="dropdown" aria-haspopup="true"
           aria-expanded="true">
            <i class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
        </a>
        <ul class="dropdown-menu dropdown-alerts" aria-labelledby="mediaFlagDropdown">
            <li class="p-sm text-right" :class="{'border-bottom': ecomCount}" v-if="discontinuedCount">
                <span class="pull-left"><strong>{{ discontinuedCount }} x </strong>Discontinued media</span>
                <span class="label label-danger"><i aria-hidden="true" class="fa fa-clock-o fa-fw"></i></span>
            </li>
            <li class="p-sm text-right" v-if="ecomCount">
                <span class="pull-left"><strong>{{ ecomCount }} x </strong>eCom media</span>
                <span class="label label-success"><i aria-hidden="true" class="fa fa-desktop fa-fw"></i></span>
            </li>
        </ul>
    </div>
</template>
